import { useEffect } from 'react';
import useLoadNewCessions from './useLoadNewCessions';

const useLoadNewCessionsOnMount = () => {
  const { loadNewCessions, selectedCompanyHasSiiCredentials } = useLoadNewCessions();

  useEffect(() => {
    if (selectedCompanyHasSiiCredentials) {
      loadNewCessions();
    }
  }, [selectedCompanyHasSiiCredentials, loadNewCessions]);
};

export default useLoadNewCessionsOnMount;
